/**
 * Settings action types
 */
export const SET_SETTING = '[SETTINGS] SET SETTING';
